// extracted by mini-css-extract-plugin
module.exports = {"PortraitCard":"PortraitCard_PortraitCard__3i9Ex","Portrait":"PortraitCard_Portrait__3s447","Name":"PortraitCard_Name__c47vA","Description":"PortraitCard_Description__1g3pK"};